var log = {
  data: {
    title: '',
    descr: '',
    menuId: '',
  },
  callback: null,
  _log(menuId, title, descr) {
    this.data.menuId = menuId
    this.data.descr = descr
    this.data.title = title
    if (this.callback) {
      let msg = '"log":'+JSON.stringify(this.data)
      let method = 'log'
      this.callback({method,msg})
    }
  }
}

/**
 * 设置回调发送消息的方法
 * @param callback
 */
log.sendFn = function(callback){
  this.callback = callback
}

/**
 * 开始会议日志
 * @param meetingName
 */
log.vconfStart = function(meetingName){
  this._log('10205','',meetingName)
}

log.vconfStop = function(meetingName){
  this._log('10206','',meetingName)
}

log.vconfMute = function(meetingName, memberName) {
  this._log('10203', '', meetingName+':'+memberName)
}

log.vconfUnmute = function(meetingName, memberName) {
  this._log('-1201', '', meetingName+':'+memberName)
}

log.vconfMuteAll = function(meetingName) {
  this._log('10204', '', meetingName)
}

log.vconfUnmuteAll = function(meetingName) {
  this._log('-1204', '', meetingName)
}

log.vconfMuteVideo = function(meetingName, memberName) {
  this._log('-1205', '', meetingName+':'+memberName)
}

log.vconfUnmuteVideo = function(meetingName, memberName) {
  this._log('-1206', '', meetingName+':'+memberName)
}

log.vconfJoin = function(meetingName, memberName) {
  this._log('10207', '', meetingName+':'+memberName)
}

log.vconfLeave = function(meetingName, memberName) {
  this._log('10202', '', meetingName+':'+memberName)
}

log.vconfMulti = function(meetingName) {
  this._log('10112', '', meetingName)
}

log.vconfStartRecord = function(meetingName) {
  this._log('-1207', '', meetingName)
}

log.vconfStopRecord = function(meetingName) {
  this._log('-1208', '', meetingName)
}
/**
 * webrtc直呼日志
 * @param caller,callee
 */
log.sendCall = function(caller,callee) {
  this._log('10104', '', caller+"=>" + callee)
}

export default {
  log
}








// WEBPACK FOOTER //
// ./src/libs/operationLog.js